<script>
export default {
  props: {
    filter: {
      type: Object,
      required: false,
      default: () => ({
        page: undefined,
        limit: undefined,
      }),
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    paginator: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: {
      type: Number,
      required: false,
      default: 20,
    },
    defaultFilter: {
      type: String,
      required: false,
      default: 'id:DESC',
    },
    expandedRow: {
      type: Array,
      required: false,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
    canChangeOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    globalFilter: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    globalFilterFields: {
      type: Array,
      required: false,
    },
  },
  emits: ['update:filter', 'row-click', 'row-reorder', 'search'],
  mounted() {
    this.$nextTick(() => {
      this.$emit('search');
    });
  },
  methods: {
    onPage(event) {},
    onSort(event) {},
  },
  computed: {
    currentFilter: {
      get: function () {
        return this.filter;
      },
      set: function (val) {
        this.$emit('update:filter', val);
      },
    },
    expandRows: {
      get: function () {
        return this.expandedRow;
      },
      set: function (val) {
        this.$emit('update:expanded-row', val);
      },
    },
  },
};
</script>

<template>
  <DataTable
    ref="table"
    :class="{'datatable-mobile': this.$isMobile()}"
    :loading="this.loading"
    always-show-paginator
    :paginator="paginator"
    paginator-template="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
    :current-page-report-template="
      $t('paginator_template_1') + ' {first}-{last} ' + $t('paginator_template_2') + ' {totalRecords}'
    "
    :rows="this.rows"
    :rows-per-page-options="[10, 20, 50, 100]"
    :row-hover="clickable"
    :selection-mode="clickable ? 'single' : undefined"
    sort-mode="multiple"
    removable-sort
    scrollable
    :filters="globalFilter"
    :global-filter-fields="globalFilterFields"
    @page="onPage($event)"
    @sort="onSort($event)"
    @row-click="$emit('row-click', $event)"
    @row-reorder="$emit('row-reorder', $event)">
    <template #empty>
      <slot name="empty" />
    </template>
    <template #expansion="slotProps">
      <slot name="expansion" :slot-props="slotProps" />
    </template>
    <Column
      v-if="canChangeOrder && !$isMobile()"
      rowReorder
      style="width: 80px"
      :header="$t('item_label.position')"
      :reorderableColumn="false" />
    <slot />
    <template #footer v-if="this.$slots.footer">
      <slot name="footer" />
    </template>
  </DataTable>
</template>
